export var FontType;
(function (FontType) {
    FontType["AKTIVGROTESK"] = "AktivGrotesk";
    FontType["AKREGULAR"] = "Ak-Regular";
    FontType["LATO"] = "Lato";
    FontType["LORA"] = "Lora";
    FontType["PLAYFAIR_DISPLAY"] = "PlayfairDisplay";
    FontType["RALEWAY"] = "Raleway";
    FontType["ROBOTO"] = "Roboto";
})(FontType || (FontType = {}));
